import React from "react";

import CurrencyConverter from "./components/CurrencyConverter";

function App() {
  return (
    <div className="App">
      <CurrencyConverter />
    </div>
  );
}

export default App;
